// Popup.tsx
import React, { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import deletemodelpopup from "../../assets/task/deletemodelpopup.svg";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import clockOuticon from "../../assets/task/login_svgrepo-com.svg";

import {
    ApolloError,
    useMutation,
    useQuery,
} from "@apollo/client";
import { format, parseISO } from "date-fns";
import { useAuth } from "../../context/AuthContext";
import { CREATE_CLOCK_IN_OUT, CREATE_TASK_MUTATION, TICKET_ACTIONS } from "../../api/mutation";
import { showError, showSuccess } from "../common/ToastNotification";
import SearchableInputsDropdown from "../common/SearchableDropdown";
import DateSelector from "../common/DateSelector";
import InputsNew from "../common/InputsNew";
import { MASTER_STATUS_VALUES } from "../../api/query";
import Loader from "../common/Loader";
import { C } from "@fullcalendar/core/internal-common";
// import SearchableInputsDropdown from "../../Common/SearchableDropdown";

interface PopupProps {
    ticketID: string;
    isOpen: boolean;
    onClose: () => void;
    refetch: any;
}

const clockInSchema = yup.object().shape({
    status: yup.string().required('This field is required')
});


const ChangeStatusPriorityPopup: React.FC<PopupProps> = ({ ticketID, isOpen, onClose, refetch }) => {
    const [statusOptions, setStatusOptions] = useState<{ key: string; name: string }[]>([]);

    //api
    const [ticketAction, { loading: ticketActionLoading }] = useMutation(TICKET_ACTIONS, {
        fetchPolicy: 'no-cache',
    })

    const { data, loading } = useQuery(MASTER_STATUS_VALUES, {
        fetchPolicy: 'no-cache',
    });

    //useEffects
    useEffect(() => {
        if (data?.master_status_values?.status_code === 200) {
            const options = data.master_status_values?.status_values?.map((item: any) => ({
                key: item.id,
                name: item.name
            }));
            setStatusOptions(options);
        }

    }, [data])

    useEffect(() => {
        if (isOpen) {
            document.body.classList.add("coverflow_hidden_scoll_bdy");

            return () => {
                document.body.classList.remove("coverflow_hidden_scoll_bdy");
            };
        }
    }, [isOpen]);

    const {
        control,
        register,
        setValue,
        trigger,
        handleSubmit,
        watch,
        reset,
        setFocus,
        formState: { errors },
    } = useForm<any>({
        resolver: yupResolver(clockInSchema),
    });

    //watch
    const watchStatus = watch('status');

    function handleSelectStatus(key: number, name: string): void {
        // setValue('statusID', key)
        setValue('status', name)
        trigger('status')
    }

    const handleCancel = () => {
        onClose();
        // reset({
        //     clientdrop: '',
        //     date: null,
        //     taskName: ''
        // });
    };

    async function onSubmit(data: any) {
        // const payload = {
        //     id: ticketID,
        //     status: data?.status
        // }

        // console.log({ payload })

        try {
            const response = await ticketAction({
                variables: {
                    id: ticketID,
                    // priority: $priority, 
                    status: data?.status
                }
            });

            if (response.data.create_clock_in_out?.errors?.length == 0) {
                onClose()
                showSuccess("Clock In successful")
            }

            if (response.data.create_clock_in_out.errors?.length > 0) {
                showError(response.data.create_clock_in_out.errors[0].messages[0]);
            }
            // if (response.data.create_goal.status_code === 200) {
            //     showSuccess(response.data.create_goal.message)
            //     navigate('/dashboard')
            // }
            // if (response.data.create_goal.status_code === 400) {
            //     showError(response.data.create_goal.message)
            // }
        } catch (error) {
            if (error instanceof ApolloError) {
                showError(error.message)
            }
        }
    }

    if (!isOpen) return null;

    return (
        <>
            <div id="model-main-blg" onClick={(e) => e.stopPropagation()}>
                <div id="inner_loader_dv">
                    {/* <div className="w-[622px] flex flex-row items-start justify-start max-w-[622px] z-[1] mq825:max-w-full m-4 schedularaddtask_main"> */}
                    <div className="clockout_time_main w-[480px] flex flex-row items-start justify-start max-w-[622px] z-[1] mq825:max-w-full m-4 schedularaddtask_main">
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            className="m-0 flex-1 rounded-radius-radius-lg bg-white border-[1px] border-solid border-surface-border flex flex-col items-center justify-start p-8 mq575:p-3 box-border gap-[23.8px] max-w-full mq825:pt-[21px] mq825:pb-[21px] mq825:box-border"
                        >
                            <div className="relative w-full" onClick={handleCancel}>
                                <img
                                    src={deletemodelpopup}
                                    alt=""
                                    className="cursor-pointer pr-0  mq575:pr-0 mq575:pt-0 w-5 h-5 absolute right-0 top-[-5px]  mq575:top-0 mq575:w-3 mq575:h-3 dark-white-img "
                                    style={{}}
                                    onClick={handleCancel} />
                            </div>
                            <div className="flex gap-[8px] items-center justify-between w-full">
                                <div className="flex flex-1 ">
                                    <SearchableInputsDropdown
                                        label="Status*"
                                        initialValue={watchStatus}
                                        placeHolder="Select Status"
                                        options={statusOptions}
                                        onSelect={handleSelectStatus}
                                        errorMessage={errors?.status}
                                    />
                                </div>
                            </div>

                            <div className="self-stretch flex flex-row items-center justify-center py-0 pr-0 gap-[8px] mq450:box-border mq950:box-border mq1425:flex-wrap mq1425:box-border">
                                <button
                                    className="w-full cursor-pointer [border:none] pxz-spacing-lg bg-surface-primary-surface py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px]   rounded-radiuscomponent-button flex flex-row items-center justify-center box-border gap-[12px] hover:bg-dodgerblue"
                                    type="submit"
                                >
                                    <img src={clockOuticon} alt="" />
                                    <div className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center inline-block min-w-[51px]">
                                        Save
                                    </div>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            {(loading || ticketActionLoading) && (
                <Loader />
            )}
        </>
    );
};

export default ChangeStatusPriorityPopup;
